/* styled-compiled.tsx generated by @compiled/babel-plugin v0.36.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import "./styled-compiled.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
var spinnerWrapperStyles = null;
export var SpinnerWrapper = function SpinnerWrapper(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("span", _extends({}, props, {
    className: ax(["_o5721jtm _1nmz9jpi _s7n418uv _18u0v77o"])
  }), children);
};